import { Component, ElementRef, ViewChild } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { TranslateService } from '@ngx-translate/core';
import { App, Platform, Config, ToastController, ActionSheetController, NavController, Nav } from 'ionic-angular';
import { TabsPage } from '../pages/tabs/tabs';
import { SettingsProvider } from '../providers/settings/settings';
import { ConfigProvider } from '../providers/config/config';
import { AdsProvider } from '../providers/ads/ads';
import { NotificationProvider } from '../providers/notification/notification';
import { UserProvider } from '../providers/user/user';
import { Storage } from '@ionic/storage';
import { TutorialProvider } from '../providers/tutorial/tutorial';
import { Deeplinks } from '@ionic-native/deeplinks';
import { TestPage } from '../pages/test-page/test-page';
import { DeeplinkProvider } from '../providers/deeplink/deeplink';
import { ResultProvider } from '../providers/result/result';
import { NewsController, NewsRespond } from '../providers/news/news-contoller';
import { StorageProvider } from '../providers/storage-service/storage-service';
import { NewsProvider } from '../providers/news/news';
import { SessionProvider } from '../providers/session/session';
import { NotificationPage } from '../pages/notification/main/notification';
import { LoaderProvider } from '../providers/loader/loader';
import { AndroidPushOptions, Push, PushObject, PushOptions } from '@ionic-native/push';
import { Diagnostic } from '@ionic-native/diagnostic';
import { WelcomeRestylePage } from '../pages/welcome/welcome-restyle/welcome-restyle';
import { EventDetailsResolver } from '../pages/event/details/event-details/event-details-resolver';
import { EventDetailsProvider } from '../providers/event-details/event-details';
import { AppDetectorProvider } from '../providers/detector/detector';
import { EventSearchPage } from '../pages/event/main/event-search/event-search';
import { timer } from 'rxjs/observable/timer';
import { TournamentService } from '../pages/apps/gamer/services/tournament.service';
import { LineUpService } from '../pages/apps/lineup/services/lineup-service';
import { ScreenRotatableService } from '../providers/screen-rotatable/screen-rotatable.service';
import { EventTester } from '../pages/event/main/event-tester/event-tester';
import { PaymentService } from '../providers/payment.service';
import { EventProvider } from '../providers/event/event';
import { EventTabsPage } from '../pages/event/details/event-tabs/event-tabs';
import { QRCodePage } from '../pages/me/qrcode/qrcode';
import { EventsLauncherPage } from '../pages/events-launcher/events-launcher';
import { DarkMode, ThemeMode } from '../providers/dark-mode/dark-mode';
declare let PushNotification: any;


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any;
  welcomePage: boolean = false;
  tabNews: boolean = false;
  isBrowser: boolean = false;
  isSponsorbar: boolean = false;
  appIsOnDevice: boolean = false;
  appName: string = "";
  adType: string;
  private toast = null;
  dataSent = false;
  
  sponsors = null;
  activeSponsor = 0;
  isPremium: boolean = false;
  constructor(
    private platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public translateService: TranslateService,
    private settingsService: SettingsProvider,
    public app: App,
    private config: Config,
    private conf: ConfigProvider,
    private toastCtrl: ToastController,
    private ads: AdsProvider,
    private userProvider: UserProvider,
    private deeplinks: Deeplinks,
    private deeplinkService: DeeplinkProvider,
    private tutorialProvider: TutorialProvider,
    private storage: Storage,
    private resultProvider: ResultProvider,
    private storageService: StorageProvider,
    private newsService: NewsProvider,
    private sessionService: SessionProvider,
    private screen: ScreenRotatableService,
    private eventDetailsResolver: EventDetailsResolver, 
    private gs: TournamentService,
    private ls: LineUpService,
    private eventService: EventProvider,
    private paymentService: PaymentService,
    private push: Push,
    private appDetector: AppDetectorProvider,
    private darkModeService: DarkMode
    ) {
      // splashScreen.hide()
    this.platform.ready().then(async () => {
      if(!appDetector.isEventsApp()) this.ads.initAds(); 
      this.userProvider.init();
      this.initSubscriptions();
      this.registerNoti();
      this.screen.lockPortraitOrientation();
      this.userProvider.init();
      this.adType = (await this.conf.config).ads.type;
      this.isBrowser = (await this.conf.config).platform.browser;
      this.appName = (await this.conf.config).appId;
      this.tabNews = (await this.conf.config).showHide.tabsNews;
      this.isSponsorbar = (await this.conf.config).ads.type === 'sponsor';
      this.isPremium = Boolean(JSON.parse(localStorage.getItem('premium'))) || false;
      this.appIsOnDevice = !this.isBrowser || (!this.platform.url().startsWith('https') || window.matchMedia('(display-mode: standalone)').matches);

      // if (!this.appDetector.isHellaApp()) this.settingsService.enableAutoLocalization();
      this.config.set('ios', 'swipeBackEnabled', true);

      if (this.adType === 'google') {
        app.setElementClass('ad-type-native', true);
      }
      setTimeout(() => {
        if (this.isPremium && !appDetector.isEventsApp()) this.ads.hide();
        splashScreen.hide();
      }, 1000);

      // this.fakeCall();
      this.ads.getSponsorAds().then(r => {
        this.sponsors = r;
        this.sponsorAds();
      });


      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      // statusBar.styleDefault();
      // statusBar.overlaysWebView(false);
      // menuCtrl.toggle();

      if ((await this.conf.config).showHide.welcomePage) {
        this.welcomePage = (await this.conf.config).showHide.welcomePage;
      }

      NewsController.getInstance().setServices(this.storageService, this.newsService, this.sessionService, this.userProvider, this.appName)

      this.translateService.get('GLOBAL_LOADING').subscribe(async (load) => {
        document.querySelector<HTMLInputElement>('.splash').className += ' fade';

        // COMMENT AFTER UPLOAD TO NGNIX
        // this.rootPage = TabsPage;

        // TEMPORARY FIX: BROWSER

        this.preloadEventsWithRoutes();

        // UNCOMMENT THE CODE BELOW AFTER UPLOAD TO NGINX
        if (this.welcomePage) {
          await this.tutorialProvider.isFirstRun().then(status => {
            if (status && !this.isBrowser) {
              this.rootPage = WelcomeRestylePage;
              this.tutorialProvider.setTutorialDone();
            } else {

              if (this.isBrowser || this.appDetector.isEventsApp())
                this.rootPage = EventSearchPage;
              else {
                this.rootPage = TabsPage;
              }
              // this.deeplinkService.getOperation("thurnauergebnisse");

            }
          });
        } else {
          if (this.isBrowser || this.appDetector.isEventsApp())
            this.rootPage = EventSearchPage;
          else {
            this.rootPage = TabsPage;
          }
          // this.deeplinkService.getOperation("thurnauergebnisse");
          this.tutorialProvider.setTutorialDone();
        }
        if (!this.appDetector.isSpooortsApp() && !this.appDetector.isTournamentApp() && !this.appDetector.isLeaderBoardApp()) this.showLocationMessage();
        this.startFailoverCheck();

        this.storage.get('resultVirtual').then((val) => {
          if (val) {
            if (!navigator.onLine) {
              window.addEventListener('online', () => {
                if (!this.dataSent) {
//alert('we are offline and there is data to send!');
                  this.resultProvider.sendVirtualResults(val).then(() => {
                    alert('we are online and there is data to send!');
                    this.storage.remove('resultVirtual');
                    this.dataSent = true;
                  });
                }
              });
            } else {
//alert('we are online and there is data to send!');
              this.resultProvider.sendVirtualResults(val).then(() => {
                alert('we are online and there is data to send!');
                this.storage.remove('resultVirtual');
                this.dataSent = true;
              });
            }
          }
        });

        if (!this.appIsOnDevice) {
          // the app is in PWA mode, we proceed to detect device and browser support:
          let userAgent = navigator.userAgent;
          if (userAgent.match(/iPhone/i) || userAgent.match(/iPad/i)) {
            //code for "add to desktop" for iOS:
            this.translateService.get('ADDTOHOME_IOS').subscribe(addToHomeI => {
              this.presentToast(addToHomeI, 'bottom', 'speech-bubble-ios');
            });
          }
        }

        // Overwrite GLOBAL_LOADING on the start
        let elem = document.querySelector('div.loading-content');
        if (elem) {
          this.translateService.get(elem.innerHTML).subscribe(ldText => {
            if (elem) elem.innerHTML = ldText;
          });
        }
      });
      statusBar.styleDefault();

      //TEST DEEPLINK
      //https://m.spooorts.de/#/events?id=18879332 
      //https://m.spooorts.de/#/thurnauergebnisse
      //https://m.spooorts.de/#/paypal?amount=1&currency=USD&id=-1&token=asdasdasdasd
      //https://m.spooorts.de/#/savepayment?id=1&token=asdasdasdasd

      //https://m.gofo.rest/#/events?id=18879332 
      //https://m.gofo.rest/#/payment?amount=1&id=asdasdasdasd
      //https://m.gofo.rest/#/success_transaction?token=AAA&evId=1232&count=1&amount=12.50&firstName=slavik&lastName=spasibo&mail=test@gmail.com
      //https://m.gofo.rest/#/secondlayer?enaOrig=We%20Love%20Paris%20Digital%20Run
      //https://m.gofo.rest/#/language?lang=en

      setTimeout(() => {
        this.paymentService.checkPaymentStatus();
        this.deeplinks.route({
          '/test': {}
        }).subscribe((match) => {
          console.log('match: ' + match);
          this.deeplinkService.handleUrl(match);
        }, (noMatch) => {
          console.log('noMatch: ' + noMatch);
          this.deeplinkService.handleUrl(noMatch);
        });
      }, 1000);
    });
  }

  ngOnInit(){
    let mode = JSON.parse(localStorage.getItem('darkMode') || `"${ThemeMode.LightMode}"`) as ThemeMode;
    this.darkModeService.setThemeMode(mode);
  }

  sponsorAds() {
    if (!this.sponsors) return;
    timer(0, 9900).subscribe(async () => {
      this.activeSponsor = (this.activeSponsor + 1) % this.sponsors.length;
    });
  }

  showLocationMessage() {
    this.tutorialProvider.isFirstRun().then((status) => {
      if (status) {
        let app = "";

        if (this.appName.includes('hella')) {
          app = "Laufgesellschaft";
        } else if (this.appName.includes('postbonn')) {
          app = "Deutsche Post Marathon Bonn";
        } else if (this.appName.includes('vivawest')) {
          app = "VIVAWEST-Marathon";
        } else if (this.appName.includes('gesunder')) {
          app = "Gesunder Hafen";
        } else if (this.appName.includes('thurnau')) {
          app = "Thurnau Läuft";
        } else if (this.appName.includes('hannover')) {
          app = "Hannover Marathon";
        } else if (this.appName.includes('leaderboard')) {
          app = "Leaderboard";
        } else {
          app = "GOForest";
        }

        if (!this.isBrowser)
          this.presentToast(this.translateService.instant("START_PERMISSION_MESSAGE", { name: app }), "bottom", "speech-bubble-ios");
      }
    });
  }

  async preloadEventsWithRoutes() {
    if (!this.appDetector.isEventsApp()) {
      let lid = (await this.conf.config).client.lid + '';

      this.eventDetailsResolver.preloadMap(lid).then((events) => {
        EventDetailsProvider.getInstance().setEvents(events);
      });
    }
  }

  presentToast(message, position, cssclass) {
    // prevent toasts from "stacking":
    if (this.toast) {
      this.toast.dismiss();
      this.toast = null;
    }
    // create a toast:
    this.toast = this.toastCtrl.create({
      message: message,
      closeButtonText: 'OK',
      showCloseButton: true,
      cssClass: cssclass,
      position: position,
      duration: 10000
    });
    this.toast.present();
  }



  startFailoverCheck() {
    // let that = this;
    // setInterval(() => {
    //   this.isSiteOnline("http://78.94.23.124/resources/images/spooorts_logo_beta.svg", function (online) {
    //     if (online) {
    //       that.conf.switchToInitialUrl();
    //       console.log('switched to initial https://spooorts.de/');
    //     } else {
    //       console.log('offline https://spooorts.de/');
    //     }
    //   });
    // }, 2000);
  }

  isSiteOnline(url, callback) {
    // try to load favicon
    var timer = setTimeout(function () {
      // timeout after 1.7 seconds
      callback(false);
    }, 1700)

    var img = document.createElement("img");
    img.onload = function () {
      clearTimeout(timer);
      callback(true);
    }

    img.onerror = function () {
      clearTimeout(timer);
      callback(false);
    }

    img.src = url;
  }

  initSubscriptions() {
    if(!this.appDetector.isEventsApp()){
      this.sessionService.requestLoggedIn.subscribe(() => {
        setTimeout(() => {
          if(!this.sessionService.profile.premium){
            this.ads.show();
          }else{
            this.ads.hide();
          }
        }, 1000);
        localStorage.setItem('premium', JSON.stringify(this.sessionService.profile.premium));
      });
      this.sessionService.requestLogout.subscribe(() => {
        localStorage.removeItem("premium");
        // height: calc(100 % - 50px)!important;
        if(!this.isPremium) this.ads.show();   
        localStorage.setItem('premium', JSON.stringify(false));
      });
    }
  }

  registerNoti() {
    if (!this.platform.is('cordova')) return;
    // to check if we have permission
    this.push.hasPermission()
      .then((res: any) => {

        if (res.isEnabled) {
          console.log('We have permission to send push notifications');
        } else {
          console.log('We do not have permission to send push notifications');
        }

      });


    if (this.platform.is('android')) {
      // Create a channel (Android O and above). You'll need to provide the id, description and importance properties.
      this.push.createChannel({
        id: "testchannel1",
        description: "My first test channel",
        // The importance property goes from 1 = Lowest, 2 = Low, 3 = Normal, 4 = High and 5 = Highest.
        importance: 3
      }).then(() => console.log('Channel created'));

      // Delete a channel (Android O and above)
      this.push.deleteChannel('testchannel1').then(() => console.log('Channel deleted'));

      // Return a list of currently configured channels
      this.push.listChannels().then((channels) => console.log('List of channels', channels))
    }

    // to initialize push notifications

    const options: PushOptions = {
      android: {
        vibrate: true,
        forceShow: true
      },
      ios: {
        alert: 'true',
        badge: true,
        sound: 'false'
      },
      windows: {},
      browser: {
        pushServiceURL: 'http://push.api.phonegap.com/v1/push'
      }
    };

    const pushObject: PushObject = this.push.init(options);

    pushObject.on('registration').subscribe((registration: any) => {
      console.log('Device registered: ' + JSON.stringify(registration));
      this.userProvider.checkLoged(registration.registrationId).then((response) => {
        console.log('update submitted! ' + response);
      })
    });

    pushObject.on('error').subscribe(error => console.error('Error with Push plugin', error));

    pushObject.on('notification').subscribe((notification: any) => {
      console.log('Received a notification: ' + JSON.stringify(notification));
    });
  }
}



// WEBPACK FOOTER //
// /src/app/app.component.ts